import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import { DEFAULT_SCORE_POLICY, type ScorePolicy } from './selectionScore';

/**
 * Fetch the R5-editable score policy. Falls back to the compiled-in
 * defaults while loading or if the request fails so scoring never
 * silently produces zero scores.
 */
export function useScorePolicy(): ScorePolicy {
  const q = useQuery({
    queryKey: ['score-policy'],
    queryFn: api.getScorePolicy,
    staleTime: 60_000,
  });
  if (!q.data) return DEFAULT_SCORE_POLICY;
  return {
    notPickedBonusPerStreak: q.data.notPickedBonusPerStreak,
    notPickedMaxBonus: q.data.notPickedMaxBonus,
    notRegisteredBonusPerStreak: q.data.notRegisteredBonusPerStreak,
    notRegisteredMaxBonus: q.data.notRegisteredMaxBonus,
    noShowPenaltyPerStreak: q.data.noShowPenaltyPerStreak,
    noShowMaxPenalty: q.data.noShowMaxPenalty,
    latePenaltyPerStreak: q.data.latePenaltyPerStreak,
    lateMaxPenalty: q.data.lateMaxPenalty,
    subsOnlyBonusPerStreak: q.data.subsOnlyBonusPerStreak,
    subsOnlyMaxBonus: q.data.subsOnlyMaxBonus,
    yellowCardFactor: q.data.yellowCardFactor,
    greenFlagFactor: q.data.greenFlagFactor,
    csSlotPreferenceFactor: q.data.csSlotPreferenceFactor,
  };
}
